// /expoTokens DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정(레이아웃 결정성 확보, 헤더 잘림 해결).
// 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { EditButton } from "@refinedev/mui";
import { IExpoToken } from "../interfaces";

export const expoTokensColumns: GridColDef<IExpoToken>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "token",
    headerName: "토큰",
    type: "string",
    width: 380,
    minWidth: 310,
  },
  {
    field: "userId",
    headerName: "수신자ID",
    type: "string",
    width: 110,
    minWidth: 90,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "deviceId",
    headerName: "장치ID",
    type: "string",
    width: 220,
    minWidth: 180,
  },
  {
    field: "accept",
    headerName: "승락",
    type: "string",
    width: 96,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "active",
    headerName: "활성여부",
    type: "string",
    width: 96,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
